module.exports = {
      id: "linkedin-usage",
      viewBox: "0 0 12 12",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#linkedin",
      toString: function () {
        return this.url;
      }
    }